import { render, staticRenderFns } from "./AutomaticSearchPage.vue?vue&type=template&id=5ba47531&"
import script from "./AutomaticSearchPage.vue?vue&type=script&lang=js&"
export * from "./AutomaticSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports